var _path, _path2, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80005 4C2.80005 1.79086 4.59091 0 6.80005 0H16.8L25.2001 8.4V24C25.2001 26.2091 23.4092 28 21.2001 28H6.80004C4.59091 28 2.80005 26.2091 2.80005 24V4Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.8 0L25.2 8.4H20.8001C18.5909 8.4 16.8 6.60914 16.8 4.4V0Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_1702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.19995 15.2002H23.6M9.19995 18.4002H23.6M9.19995 21.6002H23.6M9.19995 24.8002H20.4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2,
    height: 11.2,
    fill: "white",
    transform: "translate(8.40002 11.2002)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.843cef23fee9000e4e5753ac3096ff6d.svg";
export { ForwardRef as ReactComponent };